import React from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeftLong, faCartShopping, } from "@fortawesome/free-solid-svg-icons";
import { motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { EMenuActions } from "../../store";
import Cart from "../../Cart/cartPage";
import Card from '../Items/card';

const Favourite = () => {
    const dispatch = useDispatch();
    const cartItems = useSelector((state) => state.EMenu.cartItems);
    const showCartModal = useSelector((state) => state.EMenu.showCartModal);
    const favouriteProducts = useSelector((state) => state.EMenu.favouriteProduct);

    const handleOpenModal = () => dispatch(EMenuActions.setShowCartModal(true));

    const handleCloseReview = () => {
		dispatch(EMenuActions.setFavouritePage(false));
	};
    // console.log(favouriteProducts);
    return (
        <div>
        <div className='w-full bg-white'>
            <div className="px-9 max-sm:px-4 py-4 flex flex-row gap-2 justify-between items-center border-b-2 border-light">
                <div className="cursor-pointer">
                    <motion.div
                        whileHover={{ scale: 1.04 }}
                        transition={{ duration: 0.3 }}
                        className="w-[10%] cursor-pointer"
                        onClick={handleCloseReview}
                    >
                        <FontAwesomeIcon icon={faArrowLeftLong} size="xl" className="text-dark" />
                    </motion.div>
                </div>
                <div className="m-auto">
                    <h1 className="text-black font-bold flex justify-center">Favourite products</h1>
                </div>
                    <button
                        onClick={handleOpenModal}
                        className="md:w-[10%] xl:w-[5%] max-sm:w-5%] text-center relative p-2 mx-5 max-sm:mx-1 bg-primary/20 border-2 border-primary text-primary rounded-lg hover:bg-primary hover:text-white"
                        >
                        <FontAwesomeIcon icon={faCartShopping} size="lg" />
                        {/* barge/cart items counter */}
                        <div className="bg-secondary  h-6 w-6 absolute p-[1.5px] text-[#fff] text-sm rounded-full -top-1 -right-3">
                            {cartItems.length}
                        </div>
                    </button>
                    {showCartModal === true ? <Cart /> : ""}
            </div>
            <section className="px-6 max-sm:px-3 mt-4">
            <p className="text-lg m-1 uppercase tracking-wide font-extrabold text-dark">
                Select <span className="pl-1 font-normal">Favourites</span>
            </p>
            <div className="overflow-y-scroll h-[90vh]">
            <ul className="grid max-sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 sm:gap-3 gap-3 mb-5">
                  {favouriteProducts.map(
                    ({
                      Price,
                      time,
                      description,
                      id,
                      ProductId,
                      image,
                      ProductName,
                    }) => (
                      <Card
                        key={id}
                        ProductId={ProductId}
                        image={image}
                        ProductName={ProductName}
                        description={description}
                        Price={Price}
                        time={time}
                      />
                    )
                  )}
                </ul>
            </div>
                </section>
        </div>
        </div>
  )
}

export default Favourite
